import React, { useState } from 'react';
import { Play, X } from 'lucide-react';
import { YOUTUBE_VIDEO_ID } from '../mock';

const YT_THUMB = `https://img.youtube.com/vi/${YOUTUBE_VIDEO_ID}/maxresdefault.jpg`;

export default function Journey() {
  const [playing, setPlaying] = useState(false);

  return (
    <section id="about" className="relative py-20 md:py-28">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="text-[12px] uppercase tracking-[0.22em] text-[#162028]/60 mb-4 flex items-center gap-2">
              <span className="h-px w-8 bg-[#49001B]" /> Our Journey
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1] tracking-tight text-[#162028]">
              From a <span className="italic text-[#49001B]">blockbuster</span> start to a creative studio.
            </h2>
          </div>
          <div className="lg:col-span-7 space-y-6 text-[16px] leading-[1.75] text-[#162028]/80">
            <p>
              Founded in <span className="font-semibold text-[#162028]">2022</span>, Rabbit Box Ads embarked on its journey with a blockbuster start, handling the movie marketing for Mammootty&rsquo;s mega-hit <em>&ldquo;Christopher.&rdquo;</em> This auspicious beginning led to numerous successful film projects. In 2023, we expanded our horizon to include corporate marketing, applying our cinematic flair and innovative strategies to the corporate world.
            </p>
            <p>
              Our diverse team of Graphic Designers, Video Editors, Content Creators, Project Coordinators, Creative Directors, and Brand Managers each bring unique perspectives. Beyond marketing, we&rsquo;ve ventured into media production — creating engaging web series and feature films.
            </p>
            <p>
              Our expansion has given rise to specialised verticals — <span className="font-semibold text-[#162028]">Hue, Soul,</span> and <span className="font-semibold text-[#162028]">Loop</span> — each focusing on distinct aspects of creative and strategic marketing.
            </p>
          </div>
        </div>

        {/* Video */}
        <div className="mt-14 md:mt-20 relative rounded-3xl overflow-hidden bg-[#162028] aspect-[16/9] group">
          {!playing ? (
            <>
              <img src={YT_THUMB} alt="Rabbit Box Ads journey" onError={(e) => { e.currentTarget.src = `https://img.youtube.com/vi/${YOUTUBE_VIDEO_ID}/hqdefault.jpg`; }} className="absolute inset-0 h-full w-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#162028]/80 via-[#162028]/20 to-transparent" />
              <button onClick={() => setPlaying(true)} className="absolute inset-0 flex items-center justify-center" aria-label="Play showreel">
                <span className="relative flex h-24 w-24 md:h-32 md:w-32 items-center justify-center rounded-full bg-[#49001B] text-[#162028] shadow-2xl transition-transform hover:scale-110">
                  <span className="absolute inset-0 rounded-full bg-[#49001B] animate-ping opacity-40" />
                  <Play size={36} className="fill-[#162028] ml-1" />
                </span>
              </button>
              <div className="absolute bottom-6 left-6 md:bottom-8 md:left-8 right-6 md:right-8 flex items-end justify-between">
                <div>
                  <div className="text-[11px] uppercase tracking-[0.22em] text-[#ede2c4]/70 mb-2">Hello 2024, Thanks 2023</div>
                  <div className="font-serif-display text-2xl md:text-4xl text-[#ede2c4] max-w-2xl leading-tight">Rabbit Box Ads Journey in a Nutshell</div>
                </div>
                <div className="hidden md:block text-[11px] uppercase tracking-[0.22em] text-[#ede2c4]/60">01:03 min</div>
              </div>
            </>
          ) : (
            <>
              <iframe
                className="absolute inset-0 h-full w-full"
                src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&rel=0`}
                title="Rabbit Box Ads Journey"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
              <button onClick={() => setPlaying(false)} className="absolute top-4 right-4 h-10 w-10 rounded-full bg-[#162028]/80 text-[#ede2c4] flex items-center justify-center hover:bg-[#49001B] transition-colors" aria-label="Close video">
                <X size={18} />
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
